import axios from "../utils/axios.wrapper";

export const getCustomers = async () => {
  const { data } = await axios.get("/Customer");
  return data.items || data;
};

export const getActiveCustomers = async () => {
  const { data } = await axios.get("/Customer/active");
  return data.items || data;
};

export const getInactiveCustomers = async () => {
  const { data } = await axios.get("/Customer/inactive");
  return data.items || data;
};

export const getCustomerById = async (id) => {
  const { data } = await axios.get(`/Customer/${id}`);
  return data;
};

export const getCustomerByName = async (name) => {
  const { data } = await axios.get(`/Customer/name/${name}`);
  return data;
};

export const getCustomerByEmail = async (email) => {
  const { data } = await axios.get(`/Customer/email/${email}`);
  return data;
};

export const getCustomerByPhone = async (phone) => {
  const { data } = await axios.get(`/Customer/phone/${phone}`);
  return data;
};

export const createCustomer = async (customer) => {
  const { data } = await axios.post("/Customer/create", customer);
  return data;
};

export const updateCustomer = async (id, customer) => {
  const { data } = await axios.put(`/Customer/${id}`, customer);
  return data;
};

export const deleteCustomer = async (id) => {
  const { data } = await axios.delete(`/Customer/${id}`);
  return data;
};

export const hardDeleteCustomer = async (id) => {
  const { data } = await axios.delete(`/Customer/hard/${id}`);
  return data;
};

export const getBeneficiaryCustomers = async () => {
  const { data } = await axios.get("/Customer/beneficiaries");
  return data.items || data;
};

export const getCustomerSummaries = async (isBeneficiary = false) => {
  const { data } = await axios.get(`/Customer/summaries?isBeneficiary=${isBeneficiary}`);
  return data.items || data;
};

export const importCustomers = async (file) => {
  const formData = new FormData();
  formData.append('File', file); // Matches the backend FileUploadDto property name
  const { data } = await axios.post("/Customer/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadCustomerTemplate = async () => {
  const response = await axios.get("/Customer/download-template", {
    responseType: 'blob',
  });
  return response;
};


export const customerService = {
  getCustomers,
  getActiveCustomers,
  getInactiveCustomers,
  getCustomerById,
  getCustomerByName,
  getCustomerByEmail,
  getCustomerByPhone,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  hardDeleteCustomer,
  getBeneficiaryCustomers,
  getCustomerSummaries,
  importCustomers,
  downloadCustomerTemplate,
};
